const thresholds = {
  "Antimon (Sb)": 0.005,
  "Arsenik (As)": 0.01,
  "Bly (Pb)": 0.005,
  "Turbiditet": 3,
  "Radon": 100,
  "Kisel (Si)": 2,
  "Fluorid": 1.3,
  "Konduktivitet": 75,
  "Kadmium (Cd)": 0.0001,
  "Koppar (Cu)": 0.2,
  "Krom (Cr)": 0.025,
  "Kalium (K)": 12,
  "Marmoraggressiv kolsyra": 15,
  "Nickel (Ni)": 0.02,
  "Nitrat (NO3)": 20,
  "Nitrit (NO2)": 0.10,
  "Sulfat": 250,
  "Magnesium (Mg)": 30,
  "Mangan (Mn)": 0.3,
  "Aluminium (Al)": 0.2,
  "Ammonium": 0.5,
  "Färg (410 nm)": 30,
  "Järn (Fe)": 0.5,
  "Kalcium (Ca)": 100,
  "Klorid": 100,
  "Natrium (Na)": 100,
  "Selen (Se)": 0.02,
  "Sulfat (SO4)": 0.5,
  "Fosfat (PO4)": 0.6,
  "Uran (U)": 0.03,
  "pH": 7,
  "Aktinomyceter": 100,
  "Hårdhet": 8,
  "COD-Mn": 8,
  "Koliforma bakterier": 100,
  "Odlingsbara mikroorganismer": 1000,
  "Escherichia coli": 1,
  "Lukt": true
};

export default thresholds;